import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header4'
import Banner from '../MenHomeFour/Banner'
import Partner from '../MenHomeFour/Partner'
import About from '../MenHomeFour/About'
import Service from '../MenHomeFour/Service'
import WhyChouse from '../MenHomeFour/WhyChouse'
import Benifits from '../MenHomeFour/Benifits'
import Portfolio from '../MenHomeFour/Portfolio'
import Testimonial from '../MenHomeFour/Testimonial'
import FaQ from '../MenHomeFour/FaQ'
import Blog from '../MenHomeFour/Blog'
import Contact from '../MenHomeFour/Contact'
import Footer from '../../Global/Footer4'

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <Banner />
            <Partner />
            <About />
            <Service />
            <WhyChouse />
            <Benifits />
            <Portfolio />
            <Testimonial />
            <FaQ />
            <Blog />
            <Contact />
            <Footer />
        </>
    )
}

export default Main
